import React, { useContext, useState } from "react";
import MenuPopover from "../MenuPopover";
import { Caret, CloseIcon, ProfileIcon, BurgerButton } from "./styles";
import IconV2 from "../Icon";
import { Avatar } from "../Avatar";
import Popover from "../Popover";
import { useMediaQuery } from "react-responsive";
import { useTheme } from "styled-components";
import { AuthContext } from "../../context/AuthProvider";
import { resolveProfileIcon } from "../../utils/profileIcon";

const Menu = ({ onMenuClick, isDrawerOpen, showProfile, menuIconStyle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.mobile})`
  });
  const isDesktop = !isMobile;

  const ArrowIcon = (
    <ProfileIcon showProfile={showProfile} onClick={onMenuClick}>
      {showProfile && <span className="profile-name">{user.fullName}</span>}
      <div className="profile-right">
        {showProfile && (
          <Avatar
            className="profile-avatar"
            color={user.profileColor}
            size="24"
          >
            {resolveProfileIcon(user.profileIcon) && (
              <img
                style={{ width: 24, height: 24 }}
                className="selected-icon"
                src={resolveProfileIcon(user.profileIcon)}
                alt="profile-icon"
              />
            )}
          </Avatar>
        )}
        <Caret isOpen={isOpen} style={menuIconStyle}>
          <IconV2 type="triangle" size="xs" color="white" label="menu" />
        </Caret>
      </div>
    </ProfileIcon>
  );

  const BurgerIcon = (
    <BurgerButton
      onClick={onMenuClick}
      style={{ marginLeft: isDesktop ? 8 : 16, marginTop: -8 }}
    >
      <img
        src={require("../../assets/menu_burger.svg")}
        alt="burger-menu-icon"
        style={{ width: 30 }}
      />
    </BurgerButton>
  );

  if (isDesktop) {
    return (
      <Popover
        right={user.role === "guest" ? "-8px" : "4px"}
        top="55px"
        hideTriangle
        triggerComponent={user.role === "guest" ? BurgerIcon : ArrowIcon}
        dropdown={<MenuPopover toggleDropdown={onMenuClick} />}
        showDropdown={isDrawerOpen}
        onClose={onMenuClick}
        onChange={value => setIsOpen(value)}
      />
    );
  }
  if (!isDrawerOpen) {
    return BurgerIcon;
  }

  return (
    <CloseIcon className="close-icon" onClick={onMenuClick}>
      <IconV2 type="close" size="sm" color="white" label="close-drawer" />
    </CloseIcon>
  );
};

export default Menu;
